import React, { useState } from "react";

function Eo(props) {
  const [eo, setEo] = useState();
  const error = "Votre score doit être entre 4 et 20";
  const [nclcEO, setNclcEO] = useState("");
  function handler(e) {
    setEo(e.target.value);
  }
  const handleSubmit = (e) => {
    e.preventDefault();
    if (nclcEO !== error) {
      props.onSubmit(nclcEO);
    }
  };
  return (
    <div>
      <div className="Input">
        <span>Expression Orale :</span>
        <form className="row" onSubmit={handleSubmit}>
          <input
            className="Score"
            type={"number"}
            placeholder={"Saisissez votre score en EO.."}
            onChange={handler}
          />
          <button
            type="submit"
            className="ButtonNCLC"
            onClick={() => {
              if (eo >= 4 && eo <= 5) {
                setNclcEO(4);
              } else if (eo == 6) {
                setNclcEO(5);
              } else if (eo >= 7 && eo <= 9) {
                setNclcEO(6);
              } else if (eo >= 10 && eo <= 11) {
                setNclcEO(7);
              } else if (eo >= 12 && eo <= 13) {
                setNclcEO(8);
              } else if (eo >= 14 && eo <= 15) {
                setNclcEO(9);
              } else if (eo >= 16 && eo <= 20) {
                setNclcEO(10);
              } else {
                setNclcEO(error);
              }
            }}
          >
            NCLC
          </button>
          <h3 className="result">{nclcEO}</h3>
        </form>
      </div>
    </div>
  );
}

export default Eo;
